import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import { interfaceActions } from '../../common/redux/actions';
import * as URLs from '../../common/constants/systemUrls';

// Зависимые контейнеры
import Profiles from './containers/Profiles/Profiles';
import ProfileCard from './containers/ProfileCard/ProfileCard';

const { setCaption } = interfaceActions;

const Employees = (props) => {
	return (
		<Fragment>
			<Route
				exact
				path={'/' + URLs.EMPLOYEES}
				render={props => <Profiles {...props} />}
			/>
			<Route
				exact
				path={'/' + URLs.EMPLOYEES + '/:id(\\d+|add)'}
				render={props => <ProfileCard {...props} />}
			/>
		</Fragment>
	);
}

export default connect(
	state => ({}),
	{
		setCaption
	}
)(Employees);
